<!-- Índice -->
<div id="index" class="page d-none">
    <!-- ADN -->
    <div *ngIf="test.testModelId === 1 || (test.testModelId === 2 && !isMD)" class="mar-t-10">
        <h1 class="color-tertiary mar-b-1 title-l">{{ 'COMMON.INDEX' | translate }}.</h1>
        <div class="title-xs font-weight-bold">
        <div class="d-flex justify-content-between">
            <span>1. {{ 'COMMON.INTRODUCTION' | translate }}</span>
            <span>3</span>
        </div>
        <hr class="mar-y-1">
        <div class="d-flex justify-content-between">
            <span>2. {{ ('REPORT.CT.ADN.GENERAL.RESULTSCHART.'+ (test.adjustment ? 'ADJUSTMENT' : 'NOTADJUSTMENT') + '.TITLE') | translate }}</span>
            <span>4</span>
        </div>
        <hr class="mar-y-1">
        <ng-container *ngIf="reportType !== 'candidate'">
            <div class="d-flex justify-content-between">
            <span>3. {{ 'REPORT.CT.ADN.GENERAL.RESULTS.TITLE' | translate }}</span>
            <span>5</span>
            </div>
            <hr class="mar-y-1">
        </ng-container>
        <ng-container *ngIf="reportType === 'candidate'">
            <div class="d-flex justify-content-between">
            <span>3. {{ 'COMMON.STRENGTHS' | translate }}.</span>
            <span>5</span>
            </div>
            <hr class="mar-y-1">
            <div class="d-flex justify-content-between">
            <span>4. {{ 'COMMON.TIPS' | translate }}</span>
            <span>{{6 + dinamicPageNumber1}}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="reportType === 'consultant'">
            <div class="d-flex justify-content-between">
            <span>4. {{ 'REPORT.CT.ADN.CONSULTANT.INTERVIEWGUIDELINES.TITLE' | translate }}</span>
            <span>{{6 + dinamicPageNumber2}}</span>
            </div>
        </ng-container>
        </div>
    </div>

    <!-- MD -->
    <div *ngIf="test.testModelId === 2 && isMD" class="mar-t-10">
        <h1 class="color-tertiary mar-b-1 title-l">{{ 'COMMON.INDEX' | translate }}.</h1>
        <div class="title-xs font-weight-bold">
          <div class="d-flex justify-content-between">
            <span>1. {{ 'COMMON.INTRODUCTION' | translate }}</span>
            <span>3</span>
          </div>
          <hr class="mar-y-1">
          <div class="d-flex justify-content-between">
            <span>2. {{ 'REPORT.MINDSET.' + reportType.toUpperCase() + '.AREASCOMPETENCES' | translate }}</span>
            <span>4</span>
          </div>
          <hr class="mar-y-1">
          <div class="d-flex justify-content-between">
            <span>3. {{ 'REPORT.MINDSET.' + reportType.toUpperCase() + '.RESULTSCHART' | translate }}</span>
            <span>7</span>
          </div>
          <hr class="mar-y-1">
          <ng-container *ngIf="reportType !== 'candidate'">
            <div class="d-flex justify-content-between">
              <span>4. {{ 'REPORT.MINDSET.GENERAL.RESULTSINTERPRETATION' | translate }}</span>
              <span>8</span>
            </div>
            <hr class="mar-y-1">
          </ng-container>
          <ng-container *ngIf="reportType === 'candidate'">
            <div class="d-flex justify-content-between">
              <span>4. {{ 'COMMON.STRENGTHS' | translate }}</span>
              <span>8</span>
            </div>
            <hr class="mar-y-1">
            <div class="d-flex justify-content-between">
              <span>5. {{ 'REPORT.MINDSET.GENERAL.TIPS' | translate }}</span>
              <span>{{ 8 + dinamicPageNumber1 }}</span>
            </div>
            <hr class="mar-y-1">
          </ng-container>
        </div>
    </div>

    <!-- Inglés, Razonamiento y Conocimientos Digitales -->
    <div *ngIf="test.testModelId === 24 || test.testModelId === 25 || test.testModelId === 26" class="mar-t-10">
        <h1 class="color-tertiary mar-b-1 title-l">{{ 'COMMON.INDEX' | translate }}.</h1>
        <div class="title-xs font-weight-bold">
          <div class="d-flex justify-content-between">
            <span>1. {{ 'REPORT.CT.' + test.testModel.id + '.' + reportType + '.TITLE' | uppercase | translate }}</span>
            <span>3</span>
          </div>
          <hr class="mar-y-1">
          <div class="d-flex justify-content-between">
            <span>2. {{ 'REPORT.CT.' + test.testModel.id + '.GENERAL.RESULTSLEVEL' | uppercase | translate }}</span>
            <span>4</span>
          </div>
        </div>
    </div>

    <!-- Backgound -->
    <div class="index-background mar-t-10">
        <div class="big-circle"></div>
        <div class="medium-circle"></div>
        <div class="small-circle-1"></div>
        <div class="small-circle-2"></div>
        <div class="small-circle-3"></div>
        <div class="small-circle-4"></div>
    </div>
</div>